import { Plugin } from 'vue';
import { useBreadcrumbStore } from '@/store/breadcrumbs';

const NavigationTrackerPlugin: Plugin = {
    install(app)
    {
        const router = app.config.globalProperties.$router;
        const breadcrumbStore = useBreadcrumbStore();

        if (router)
        {
            router.afterEach(async (to, from) =>
            {
                // Skip if it's the same route
                if (to.fullPath === from.fullPath)
                {
                    return;
                }

                // Get the sitemap node for the current route
                const sitemap = app.config.globalProperties.$sitemap;

                if (sitemap && to.name)
                {
                    try
                    {
                        // Check if auth is ready before trying to access sitemap
                        const auth = app.config.globalProperties.$auth;

                        if (!auth || !auth.ready())
                        {
                            return;
                        }

                        // Skip sitemap lookup on auth route
                        if (to.path.includes('/auth/'))
                        {
                            return;
                        }

                        if (to.meta.externalAccess)
                        {
                            return;
                        }

                        const sitemapNode = await sitemap.find(to);

                        if (sitemapNode)
                        {
                            await breadcrumbStore.updateBreadcrumbs(to, sitemapNode);
                        }
                    }
                    catch (error)
                    {
                        console.error('Error tracking navigation:', error);
                    }
                }
            });
        }
    }
};

export default NavigationTrackerPlugin;
